module.exports = __webpack_public_path__ + "img/map_florida_bg_3.ce5d0314.jpg";